import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspacesApi as n } from "@maat/api-main";
//#region src/workspaces/useWorkspacesQuery.ts
var r = (r) => t({
	queryKey: e.list(),
	queryFn: n.getMyWorkspaces,
	enabled: r
});
//#endregion
export { r as useWorkspacesQuery };
